import type {ReactElement} from 'react';
import {IconShape, IconSize} from '@Components/icon-v2/icon.types';
import {Icon} from '@Components/icon-v2';
import styles from './event-wizard-premium-icon.module.scss';
import type {EventWizardPremiumIconProps} from '@Components/event-wizard/event-wizard-premium-icon/event-wizard-premium-icon.types';
import {openEventsUpsellDialog} from "@Libraries/events.library";

export function EventWizardPremiumIcon({upsellType}: EventWizardPremiumIconProps): ReactElement<any> {
  return (
    <Icon
      isUsedAsButton
      onClick={() => {
          openEventsUpsellDialog(upsellType, undefined);
      }}
      className={`${styles.premiumIconColor} spacing-p-0 spacing-m-l-1`}
      icon="icon-crown"
      shape={IconShape.CIRCLE}
      size={IconSize.SIZE_ICON_16}
    />
  );
}
